import angular from 'angular';
import recommendationsModule from "../recommendationsModule.js";

function recommendationsController($rootScope, recommendationsService, recommendationsConstants, $log, thumbnailConstants, urlService) {
    "ngInject";
    var ctrl = this;

    var init = function () {
        ctrl.thumbnailSizes = thumbnailConstants.sizes;

        if (!ctrl.recommendationTargetId) {
            ctrl.recommendationTargetId = 0;
        }

        recommendationsService.getCatalogMetadata(ctrl.pageName).then(function (result) {
            ctrl.numberOfItems = result.numOfRecommendationsDisplayed;
            ctrl.isBundleRecommendationsEnabled = result.isBundleRecommendationsEnabled;
            ctrl.getItems();
        }, function (error) {
            $log.debug(" ------ getCatalogMetadata error -------");
            $rootScope.isRecommendationsLoaded = true;
        });
    }

    ctrl.absoluteCatalogUrl = urlService.getAbsoluteUrl(recommendationsConstants.urls.catalog);

    ctrl.clearItems = function () {
        ctrl.items = [];
    };

    ctrl.getItems = function () {
        ctrl.items = [];

        if (!recommendationsService.canShowRecommendationsForType(ctrl.recommendationType, ctrl.recommendationSubtype)) {
            $rootScope.isRecommendationsLoaded = true;
            return;
        }

        if (ctrl.recommendationType === recommendationsConstants.recommendationTypes.bundles && !ctrl.isBundleRecommendationsEnabled) {
            $rootScope.isRecommendationsLoaded = true;
            return;
        }

        recommendationsService.beginUpdateRecommendedItems(ctrl.recommendationTargetId, ctrl.recommendationType, ctrl.recommendationSubtype, ctrl.numberOfItems)
            .then(function (result) {
                ctrl.items = result;
            }, function (error) {
                $log.debug(" ------ beginUpdateRecommendedItems error -------");
            })
            .finally(function () {
                $rootScope.isRecommendationsLoaded = true;
            });
    }

    ctrl.$onInit = init;

    ctrl.$onChanges = function (changes) {
        if (ctrl.numberOfItems // We've received the metadata response
            && ((ctrl.recommendationType !== undefined && changes.recommendationType !== undefined)
            || (ctrl.recommendationSubtype !== undefined && changes.recommendationSubtype !== undefined))) {
            ctrl.getItems();
        }
    };
};

recommendationsModule.controller("recommendationsController", recommendationsController);
export default recommendationsController;